import { render, staticRenderFns } from "./CardDescription.vue?vue&type=template&id=e12b75ba&scoped=true&"
import script from "./CardDescription.vue?vue&type=script&lang=js&"
export * from "./CardDescription.vue?vue&type=script&lang=js&"
import style0 from "./CardDescription.vue?vue&type=style&index=0&id=e12b75ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12b75ba",
  null
  
)

/* custom blocks */
import block0 from "@/locales/card_description.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvar%2Fjenkins%2Fworkspace%2Fon-production-deploy%2Ffront%2Fcomponents%2F_shared%2FCards%2FCardDescription.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports